import { render, staticRenderFns } from "./orgDetail.vue?vue&type=template&id=e678bb80&scoped=true"
import script from "./orgDetail.vue?vue&type=script&lang=js"
export * from "./orgDetail.vue?vue&type=script&lang=js"
import style0 from "./orgDetail.vue?vue&type=style&index=0&id=e678bb80&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e678bb80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e678bb80')) {
      api.createRecord('e678bb80', component.options)
    } else {
      api.reload('e678bb80', component.options)
    }
    module.hot.accept("./orgDetail.vue?vue&type=template&id=e678bb80&scoped=true", function () {
      api.rerender('e678bb80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/orgDetail.vue"
export default component.exports